import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import { Input, Select } from "components/base/Form";
import { Alert } from "components/base/Toast";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PRODUCTION_OWNERS } from "../consts";
import { CREATE_GTM_PROJECT } from "../graphql";

const PROJECT_TYPES = ["NEW_PACKAGING", "UPDATE_PACKAGING"];

const CreateGTMProjectView = () => {
  const [name, setName] = useState("");
  const [ownerId, setOwnerId] = useState(null);
  const navigate = useNavigate();

  const [createGtmProject, createGtmProjectRes] = useMutation(
    CREATE_GTM_PROJECT,
    {
      variables: { name, ownerId },
      onCompleted(res) {
        Alert("success", "Go to Market Project created successfully");
        const id = res.createGtmProject.gtmProject.id;
        navigate(`/development/gtm-projects/${id}`);
      },
      onError(error) {
        Alert("error", parseError(error));
      },
      refetchQueries: ["FETCH_GTM_PROJECTS"],
    },
  );

  return (
    <div>
      <div className="-mx-2">
        <table className="whitespace-nowrap">
          <tbody>
            <tr>
              <td>Project Name: </td>
              <td className="w-full">
                <Input
                  className="w-full"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </td>
            </tr>
            <tr>
              <td>Product Owner: </td>
              <td>
                <Select
                  value={ownerId || "0"}
                  onChange={(e) => setOwnerId(e.target.value)}
                >
                  <option value="0" disabled>
                    Choose Owner
                  </option>
                  {PRODUCTION_OWNERS.map((owner) => (
                    <option key={owner.id} value={owner.id}>
                      {owner.name}
                    </option>
                  ))}
                </Select>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <Button
        primary
        className="mt-6 text-xs"
        onClick={createGtmProject}
        disabled={!name || !ownerId}
        loading={createGtmProjectRes.loading}
      >
        Create GTM Project
      </Button>
    </div>
  );
};

export default CreateGTMProjectView;
